import * as type from './constant';

export const getInstruction = (params = undefined, selfRole = undefined) => ({
  type: type.GET,
  params,
  selfRole,
});

export const getInstructionSuccess = (payload, selfRole = '') => ({
  type: type.GET_SUCCESS,
  payload,
  selfRole,
});

export const getInstructionError = (error) => ({
  type: type.GET_ERROR,
  error,
});

export const addInstruction = (payload, selfRole = undefined) => ({
  type: type.ADD,
  payload,
  selfRole
});

export const addInstructionSuccess = (payload) => ({
  type: type.ADD_SUCCESS,
  payload,
});

export const updateInstruction = (id, payload, selfRole = undefined) => ({
  type: type.UPDATE,
  id,
  payload,
  selfRole,
});

export const updateInstructionSuccess = (payload) => ({
  type: type.UPDATE_SUCCESS,
  payload,
});

export const deleteInstruction = (ids, selfRole = undefined) => ({
  type: type.DELETE,
  ids,
  selfRole,
});

export const deleteInstructionSuccess = (payload) => ({
  type: type.DELETE_SUCCESS,
  payload,
});

export const manipulationInstructionError = (error) => ({
  type: type.MANIPULATION_ERROR,
  error,
});
